import { render } from "./MdFabExtended.vue?vue&type=template&id=c3d4cef8&scoped=true&ts=true"
import script from "./MdFabExtended.vue?vue&type=script&lang=ts"
export * from "./MdFabExtended.vue?vue&type=script&lang=ts"

import "./MdFabExtended.vue?vue&type=style&index=0&id=c3d4cef8&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d4cef8"]])

export default __exports__